/**
 * Formato de fechas en español chileno (America/Santiago).
 * TZ del navegador se ignora — el backend ya envía dates como YYYY-MM-DD (fecha local Chile).
 */

/** ISO YYYY-MM-DD → DD-MM-YYYY. Devuelve el string original si no coincide. */
export function fmtDate(iso) {
  if (!iso || typeof iso !== 'string') return iso || '';
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[3]}-${m[2]}-${m[1]}`;
}

/** ISO datetime → DD-MM-YYYY HH:mm (America/Santiago). */
export function fmtDateTime(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    const s = d.toLocaleString('es-CL', {
      timeZone: 'America/Santiago',
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false,
    });
    // es-CL retorna "03-09-2026 04:59" ó "03-09-2026, 04:59" según navegador → normalizamos
    return s.replace(',', '');
  } catch {
    return iso;
  }
}

/** DD-MM-YYYY → YYYY-MM-DD (para inputs date). */
export function toIsoDate(ddmmyyyy) {
  if (!ddmmyyyy) return '';
  const m = ddmmyyyy.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : ddmmyyyy;
}

/** Formatea el cupo máximo: valores legacy sentinela (>= 99999) se muestran como ∞. */
export function fmtCupo(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '';
  if (v >= 99999) return '∞';
  return String(v);
}
